import { ReactNode } from 'react'
// import { useLocation } from 'react-router-dom'
import { useAppDispatch } from '../store/hooks'
import { usePatientId } from 'hooks/useQueryPerams';
import { useIsDashboardEmbedded } from 'hooks/useEmbedded';
import { setEmbeddedPage, setPatientID } from 'store/authSlice';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card'
import { Button } from '../components/ui/button'
import { AlertTriangle } from 'lucide-react'

interface EmbeddedRouteProps {
  children: ReactNode
}

export function EmbeddedRoute({ children }: EmbeddedRouteProps) {
  // const location = useLocation();
  const dispatch = useAppDispatch();

  const isEmbeddedPage = useIsDashboardEmbedded();
  const patientID = usePatientId();

  dispatch(setEmbeddedPage(isEmbeddedPage));
  dispatch(setPatientID(patientID));

  if (isEmbeddedPage && !patientID) {
    return (
      <div className="flex h-screen items-center justify-center p-4 bg-background">
        <Card className="w-full max-w-md border shadow-sm">
          <CardHeader>
            <div className="flex items-center gap-2">
              <div className="h-9 w-9 rounded-[10%] bg-amber-100 flex items-center justify-center">
                <AlertTriangle className="h-5 w-5 text-amber-600" />
              </div>
              <div>
                <CardTitle className="text-base">Missing Patient Context</CardTitle>
                <CardDescription>Please provide a valid patient to load the embedded assistant.</CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="text-sm text-muted-foreground">
              This page is intended to be opened from a host application with a patient identifier.
            </div>
            <div className="flex gap-2">
              <Button variant="default" onClick={() => window.location.reload()}>
                Reload
              </Button>
              <Button variant="outline" onClick={() => (window.location.href = '/dashboard')}>
                Go to Dashboard
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }

  return <>{children}</>
} 